import { useEffect, useLayoutEffect, useState } from 'react'
import { Button, Grid } from '@mui/material'
import { Box } from '@mui/system'
import Logo from 'components/Logo'
import Buttons from './components/Buttons'
import ToggleButtons from './components/ToggleButtons'
import Title from './components/Title'
import Form from './components/Form'
import { useAuthToken } from 'hooks/useAuthToken'
import { useSearchParams } from 'react-router-dom'

const FormQuotes = ({ isMobile, setCurrentBrand, currentBrand }) => {
  const [alignment, setAlignment] = useState(1);
  const [title, setTitle] = useState({
    titleOne: 'Información general',
    titleTwo: 'Clasificación de Riesgos',
  });
  const [titleText, setTitleText] = useState('')
  const [numPage, setNumPage] = useState(1)


  const handleChangeTitleOne = (event, newValue) => {
    setTitle({ ...title, titleOne: newValue });
  };

  const handleChangeTitleTwo = (event, newValue) => {
    setTitle({ ...title, titleTwo: newValue });
  };

  const handleAlignment = (event, newAlignment) => {
    if(newAlignment == null){
      return
    }
    setAlignment(newAlignment);
    setNumPage(newAlignment === 1 ? 1 : newAlignment === 2 ? 4 : false)
  };

  const handleChangeSetNumPage = () => {
    setNumPage(numPage + 1)
  }

  const handleChangeSetNumPageAndAlignment = (newAlignment) => {
    setNumPage(numPage + 1)
    setAlignment(newAlignment);
  }

  const props = {
    alignment,
    handleAlignment,
    title
  }

  const styleButton =  (color, margin) => {
    return {
      width: '100%',
      backgroundColor: color,
      color: '#FFF',
      marginTop: margin ? margin : '30px',
      '&:focus': {
        backgroundColor: color
      }
    }
  }

  useEffect(() => {
    setTitleText(alignment === 1 ? 'Información general' : alignment === 2 ? 'Clasificación de Riesgos' : 'No se encuentra formulario')
  }, [alignment])

  return (
    <>
      {
        isMobile ? (
          <Box padding={'8px 24px'} width={'%'} >
            <Logo brandSelect={currentBrand} />
            <Grid margin={'32px 0 0 0'} container spacing={0.8} width={'100%'}>
              <Grid sx={{ '&.MuiGrid-item': {padding: '0 0 0 0'} }} item xs={12}>
                <ToggleButtons props={props} />
              </Grid>
            </Grid>
            <Box margin={'12px 0 0 0'}>
              <Title text={titleText} />
              <Form isMobile={isMobile} numPage={numPage} setCurrentBrand={setCurrentBrand} styleButton={styleButton}>
                { numPage === 3 ? (
                  <Buttons onClick={() => handleChangeSetNumPageAndAlignment(2) } text={'Ir paso 2'} sx={styleButton('#2E2C2B')} />
                ) : numPage === 6 ? (
                  <Buttons type='submit' text={'Finalizar'} sx={styleButton('#2E2C2B')} />
                ) : (<Button onClick={handleChangeSetNumPage} sx={styleButton('#E7662B')} >Continuar</Button>)}
              </Form>
            </Box>
          </Box>
        ) : (
          <Box margin={'auto'} padding={'40px 0px'} width={'60%'} >
            <Logo brandSelect={currentBrand} />
            <Grid margin={'48px 0 0 0'} container spacing={0.8} width={'100%'}>
              <Grid sx={{ '&.MuiGrid-item': {padding: '0 0 0 0'} }} item xs={12}>
                <ToggleButtons props={props} />
              </Grid>
            </Grid>
            <Box margin={'20px 0 0 0'}>
              <Title text={titleText} />
              <Form isMobile={isMobile} numPage={numPage} setCurrentBrand={setCurrentBrand} styleButton={styleButton}>
              { numPage === 3 ? (
                  <Buttons onClick={() => handleChangeSetNumPageAndAlignment(2) } text={'Ir paso 2'} sx={styleButton('#2E2C2B')} />
                ) : numPage === 6 ? (
                  <Buttons type='submit' text={'Finalizar'} sx={styleButton('#2E2C2B')} />
                ) : (<Button onClick={handleChangeSetNumPage} sx={styleButton('#E7662B')} >Continuar</Button>)}
              </Form>
            </Box>
          </Box>
        )
      }
    </>
  )
}

export default FormQuotes
